export const strings = {
  newly_added_post: 'Yeni Eklenen Gönderiler',
  registered: 'Kaydedildi',
  group_activities: 'Grup aktiviteleri',
  webinar_analytics: 'Webinar Analitği',
  analytics_overview: 'Analitiğe genel bakış',
  analytics_total: 'Toplam analitik',
  total_no_of_members: 'Toplam üye sayısı',
  total_no_of_groups: 'Toplam grup sayısı',
  upcoming_webinar: 'Yaklaşan webinarlar',
  total_webinars: 'Toplam webinars',
  total_no_registration: 'Kayıt sayısı',
  for_upcoming_webinar: 'Yaklaşam webinarlar için',
  total_number_of_registrations: 'Toplam kayıt sayısı',
  total_registration: 'Toplam kayıt',
  total_activities: 'toplam aktiviteler',
  no_of_members_joined: 'Kayıtlı üye sayısı',
  activities: 'Aktiviteler = Gönderi, Beğeni ve Yorum',
  total_no_posts: 'Toplam Gönderi Sayısı',
  total_no_likes: 'Toplam Beğeni Sayısı',
  comments: 'Yorumlar',
  export_comments: 'Yorumları Dışa Aktar',
  export_cases: 'Vakaları Dışa Aktar',
  microsite_analytics: 'Mikrosite Analitiği',
  microsite_active_members: 'Mikrosite Aktif Üyeler',
  likes: 'Beğeniler',
  posts: 'Gönderiler',
  present: '- Sunmak',
  webinars: 'Web seminerleri',
  webinar: 'Web semineri',
  members: 'Üyeler',
  groups: 'Gruplar',
  member: 'Üye',
  group: 'Grup',
  total_cases: 'Toplam Vaka Sayısı',
  total_cases_questions: 'Toplam Vaka/Soru',
  total_open_cases: 'Toplam Açık Davalar',
  total_open_cases_questions: 'Toplam Açık Davalar/Sorular',
  total_closed_cases: 'Toplam Kapatılan Davalar',
  total_comments: 'Toplam Yorum Sayısı',
  num_total_comments: '{num} Yorum',
  reminders_sent: 'Gönderilen Hatırlatmalar',
  num_reminders_sent: '{num} Hatırlatma',
  last_login: 'Son Giriş',
  num_total_cases: '{num} Toplam Vaka',
  num_total_cases_questions: '{num} Toplam Vaka/Soru',
  resolved_cases: 'Çözülen Davalar',
  resolved_cases_questions: 'Çözülen Davalar/Sorular',
  num_resolved_cases: '{num} Çözülen Vaka',
  num_resolved_cases_questions: '{num} Çözülen Vaka/Soru',
  num_open_cases: '{num} Açık Vaka',
  avg_time_case_resolve: 'Vakaların çözülme süresi ortalaması',
  avg_time_case_question_resolve:
    'Vakaların/Soruların çözülme süresi ortalaması',
  total_hcp: 'Toplam HCP',
  num_total_hcp: '{num} HCP',
  active_hcp: 'Aktif HCP',
  num_active_hcp: '{num} HCP',
  avg_rating: 'Ortalama Puanlar',
  num_avg_rating: '{num} / 5',
  overview: 'Genel Bakış',
  export_case: 'Vakaları Dışa Aktar',
  export_panel: 'Paneli Dışa Aktar',
  total_hcp_tooltip:
    "Toplam HCP, bu organizasyona kayıtlı tüm Uzmanlar ve HCP'lerden (Yöneticiler hariç) oluşur",
  active_hcp_tooltip:
    "Son 24 Saatte aktif olan tüm Uzmanlar ve HCP'ler (Yöneticiler hariç)",
  pending_tooltip: 'Şu anda tarayıcı tarafından incelenen varlıklar',
  returned_tooltip:
    "Tarayıcı tarafından incelenmiş ve şu anda gözden geçirilmek ve yeniden gönderilmek üzere hcp'ye iade edilmiş varlıklar",
  newcases_hcp_tooltip: 'Son 24 Saatte Panele atanan varlıklar',
  open_tooltip: 'Açık olan varlıklar',
  popup_blocker: 'Hata!',
  popup_blocker_description:
    'Tarayıcınızdaki bir AdBlock / Popup engelleyici, dosya indirilirken bir sorun yaratıyor, lütfen bu web sitesinden engelleyiciyi devre dışı bırakın veya dosyayı indirmek için aşağıdaki düğmeye tıklayın.',
};
